import angular from "angular";
import uiRouter from "angular-ui-router";
import "ngstorage";
import auth from "../../services/auth.js";
import events from "../../services/events.js";
import security from "../../services/security.js";
import common from "../../services/common.js";
import companies from "../../services/companies.js";
import env from "../../services/env.js";
import {UPDATE_WORKFLOW_EVENT_NAME} from "../../scenes/postashiftwalkthrough/variables";

let DAYS_OF_WEEK = {
  MONDAY: 1,
  TUESDAY: 2,
  WEDNESDAY: 3,
  THURSDAY: 4,
  FRIDAY: 5,
  SATURDAY: 6,
  SUNDAY: 0,
};

let DAYS_OF_WEEK_OBJECTS = [
  {
    value: DAYS_OF_WEEK.SUNDAY,
    label: "Sun",
  },
  {
    value: DAYS_OF_WEEK.MONDAY,
    label: "Mon",
  },
  {
    value: DAYS_OF_WEEK.TUESDAY,
    label: "Tue",
  },
  {
    value: DAYS_OF_WEEK.WEDNESDAY,
    label: "Wed",
  },
  {
    value: DAYS_OF_WEEK.THURSDAY,
    label: "Thu",
  },
  {
    value: DAYS_OF_WEEK.FRIDAY,
    label: "Fri",
  },
  {
    value: DAYS_OF_WEEK.SATURDAY,
    label: "Sat",
  },
];

class EventeditdetailsController {
  constructor(
    $http,
    $localStorage,
    $state,
    $stateParams,
    AuthService,
    EventsService,
    SecurityService,
    $rootScope,
    CommonService,
    CompaniesService,
    EnvService,
    $timeout,
    $scope
  ) {
    this.name = "eventeditdetails";
    $localStorage.activeStateName = "events";

    if (!AuthService.isLoggedIn()) {
      $state.go("signin");
      return;
    }

    this.$http = $http;
    this.$localStorage = $localStorage;
    this.$state = $state;
    this.$auth = AuthService;
    this.$events = EventsService;
    this.$stateParams = $stateParams;
    this.$security = SecurityService;
    this.$rootScope = $rootScope;
    this.$common = CommonService;
    this.$companies = CompaniesService;
    this.$env = EnvService;
    this.$timeout = $timeout;
    this.payBeforeChange = null;
    this.shiftsHolder = [];
    this.shiftsToBeDeleted = [];
    this.activeTab = "edit-job";
    this.currentUser = this.$auth.getUserData();
    this.event = {};
    this.$scope = $scope;
    this.shiftsEdited = false;
    this.teams = [];
    this.eventTypes = [];
    this.jobbleTypes = [];
    this.isEventUpdateValidateError = false;
    this.updateStatus = 0;
    this.errorMessage = "";
    this.openingsList = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
    this.hoursList = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];
    this.WEEKS_AVAILABLE = this.$auth.isAdmin() ? [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15] : [3, 4, 5];
    this.minutesList = [];
    this.unpaidBreakList = [];
    this.jobbles = [];
    this.tempPay = 0;
    this.shiftIsBeingEdited = false;
    this.additionalDays = 0;
    this.tempOpenings = 0;
    this.googleMapKey = this.$auth.$env.EnvironmentConfig.mapsKey;
    this.fullGoogleUrl = "https://maps.googleapis.com/maps/api/js?libraries=places&key=" + this.googleMapKey;

    for (var i = 0; i <= 60; i++) {
      if (i % 15 === 0) {
        this.minutesList.push(i);
        this.unpaidBreakList.push(i);
      }
    }

    this.remain_loading_count = 1;
    this.setLoader();

    var _this = this;

    _this.showTimeToHire();

    _this.$timeout(function () {
      _this.$rootScope.$emit("SetLoaderDialog", {type: 3, total: 1});
    });

    this.$events.getShiftRequirements(this.$stateParams.eventId).then((data) => {
      this.event_requirements = data.data;
    });

    this.$events.getEventByIdWithFields(this.$stateParams.eventId, 1).then(
      function (data) {
        _this.event = data.data;
        _this.getUpdatedData();

        if (_this.event.numberOfApprovedApplications > 0) {
          _this.tempPay = (_this.event.subEvents[0].deduppedJobbles[0].payPerHour / 100).toFixed(2);
        } else {
          _this.tempPay = 11;
        }

        _this.isPrivateJob = _this.event.subEvents[0].deduppedJobbles[0].forCircleOnly;
        _this.tempOpenings = _this.event.numberOfOpenings;

        var userTimeZoneName = moment.tz.guess();
        var now = moment.tz(userTimeZoneName);

        _this.$timeout(function () {
          _this.$rootScope.$emit("SetEventToEventSidebar", {
            event: _this.event,
          });
        });

        if (_this.event.surveyQuestions) {
          _this.event.surveyQuestions.sort(function (a, b) {
            let order = null;

            if (a.displayOrder) {
              order = a.displayOrder - b.displayOrder;
            } else {
              order = a.id - b.id;
            }

            return order;
          });
        }

        if (_this.event.status === "error") {
          return;
        }

        _this.event.numberOfOpenings = _this.event.numberOfOpenings + _this.event.numberOfApprovedApplications;
        _this.event.numberOfOpeningsOrigin = _this.event.numberOfOpenings;

        let companyFeePct = _this.currentUser.company.defaultPlan.companyFeePct;
        _this.event.payPerHour = _this.event.subEvents[0].deduppedJobbles[0].payPerHour / 100;
        _this.event.payPerHourAdj = _this.event.payPerHour;
        let costPlusMarkUp = Math.round(parseFloat(_this.event.payPerHourAdj) * 100 * (1 + companyFeePct));

        _this.event.payPerHour = costPlusMarkUp / 100;
        _this.event.changedEventData = false;
        _this.event.changedJobbleData = false;
        _this.event.weeks = _this.event.weeks ? _this.event.weeks + "" : _this.event.weeks;

        let shifts = _this.event.subEvents[0].deduppedJobbles[0].shifts;

        try {
          for (var x = 0; x < shifts.length; x++) {
            let start = new Date(moment(shifts[x].timeInterval.startTime).format());
            let end = new Date(moment(shifts[x].timeInterval.endTime).format());
            let startMoment = moment(start);
            let endMoment = moment(end);
            let timeZone = shifts[x].contactInfo.place.timeZoneId;

            shifts[x].startDateFormatted = startMoment.tz(timeZone).format("MMM DD, YYYY");
            shifts[x].startDateFormattedNew = startMoment.tz(timeZone).format("M/D/YYYY");
            shifts[x].endDateFormattedNew = endMoment.tz(timeZone).format("M/D/YYYY");
            shifts[x].startTimeFormatted = startMoment.tz(timeZone).format("h:mmA");
            shifts[x].isChangedAddress = false;
            shifts[x].buttonState = "hide-button";
            _this.showDateAndTimeUI(x);
          }
        } catch (err) {
          console.log("what is the error");
          console.dir(err);
        } finally {
          _this.sortShiftsInOrder(shifts, _this.event);

          _this.$events.getAllShiftRequirements().then(function (s) {
            _this.ALL_PHYSICAL_REQUIREMENTS = s.data;
            _this.PHYSICAL_REQUIREMENTS = s.data;
            _this.filterRequirements();
          });

          if (_this.event.isSourcingPost) {
            _this.$timeout(function () {
              _this.$rootScope.$emit("SetLoaderDialog", {
                type: 0,
              });
              $("eventsidebar .jobs-complete-sidebar li:nth-child(5)").removeClass().addClass("active");
            }, 300);
          } else {
            _this.$timeout(function () {
              _this.$rootScope.$emit("SetLoaderDialog", {
                type: 0,
              });
              //_this.shifts = shifts;
              //_this.event.subEvents[0].deduppedJobbles[0].shifts = shifts;
              $("eventsidebar .jobs-complete-sidebar li:nth-child(2)").removeClass().addClass("active");
            }, 300);
          }
        }

        _this.$timeout(function () {
          _this.$rootScope.$emit("SetEventToEventDialog", {
            event: _this.event,
          });
          _this.remain_loading_count--;
        });
      },
      function (data) {
        _this.remain_loading_count--;
        _this.unSetLoader();
        $state.go("jobsdashboard");
      }
    );

    _this.jobbleTypes = _this.$rootScope.jobble_types;

    _this.SetEventToEventPagesListener = _this.$rootScope.$on("SetEventToEventPages", function ($event, params) {
      if (_this.event.id === params.event.id) {
        _this.event.cost = params.event.cost;
        _this.event.numberOfOpenings = params.event.numberOfOpenings;
        _this.event.totalNumberOfJobbles = params.event.totalNumberOfJobbles;
      }
    });

    _this.SetOnSiteManagerEditListener = _this.$rootScope.$on("SetOnSiteManagerEdit", function ($event, params) {
      _this.manager_id_for_edit = params.data;
      _this.event.changedJobbleData = true;
    });

    _this.SetJobbleTypesListener = _this.$rootScope.$on("SetJobbleTypes", function ($event, params) {
      _this.jobbleTypes = params.jobbleTypes;
    });

    _this.SuccessToDeleteEventListener = _this.$rootScope.$on("SuccessToDeleteEvent", function ($event, params) {
      _this.$state.go("jobsdashboard");
    });

    _this.$scope.$on("$destroy", _this.SuccessToDeleteEventListener);
    _this.$scope.$on("$destroy", _this.SetJobbleTypesListener);
    _this.$scope.$on("$destroy", _this.SetOnSiteManagerEditListener);
    _this.$scope.$on("$destroy", _this.SetEventToEventPagesListener);

    this.shiftLongTermGenerator = this.getNewLongTermShiftObject();

    this.DAYS_OF_WEEK = DAYS_OF_WEEK;
    this.DAYS_OF_WEEK_OBJECTS = DAYS_OF_WEEK_OBJECTS;
  }

  getNewShiftObject() {
    return {
      startDate: null, //"08/21/2020",
      endDate: null, //"08/21/2020",
      startTime: null, //"8:00",
      endTime: null, //"21:00",
      overnight: false,
      unpaidBreak: 0,
      hasUnpaidBreak: false,
    };
  }

  getNewLongTermShiftObject() {
    let shift = this.getNewShiftObject();
    shift["weeks"] = "4";
    shift["daysOfWeek"] = [];
    return shift;
  }

  processShifts(shifts) {
    return shifts.map((shift) => {
      const startTime = moment(shift.timeInterval.startTime);
      const endTime = moment(shift.timeInterval.endTime);
      const startTimeFormatted = startTime.format("h:mm a").toUpperCase();

      return {
        id: shift.id,
        startDate: startTime.format("MM/DD/YYYY"),
        endDate: endTime.format("MM/DD/YYYY"),
        startTime: startTimeFormatted,
        endTime: endTime.format("h:mm a").toUpperCase(),
        overnight: shift.overnight,
        contactInfo: shift.contactInfo,
        possibleEndTimes: [],
        unpaidBreak: shift.unpaidBreak,
        hasUnpaidBreak: shift.unpaidBreak > 0,
      };
    });
  }

  updateLongTermGenerator(raw_shifts, event) {
    let shifts = this.processShifts(raw_shifts);

    if (!this.shiftLongTermGenerator) this.shiftLongTermGenerator = this.getNewLongTermShiftObject();

    if (shifts && shifts.length) {
      this.$timeout(() => {
        this.shiftLongTermGenerator.daysOfWeek = [];
        shifts.forEach((shift, i) => {
          const dayOfWeek = new Date(shift.startDate).getDay();
          this.shiftLongTermGenerator.daysOfWeek.push(dayOfWeek);

          if (i === 0) {
            this.shiftLongTermGenerator.startDate = shift.startDate;
            this.shiftLongTermGenerator.startTime = shift.startTime;
            this.shiftLongTermGenerator.endTime = shift.endTime;
            this.shiftLongTermGenerator.overnight = shift.overnight;
            this.shiftLongTermGenerator.unpaidBreak = shift.unpaidBreak;
            this.shiftLongTermGenerator.hasUnpaidBreak = shift.hasUnpaidBreak;
            this.shiftLongTermGenerator.weeks = event.weeks;
          }
        });

        this.shiftLongTermGenerator.daysOfWeek = _.uniq(this.shiftLongTermGenerator.daysOfWeek);
      });
    }
  }

  filterRequirements() {
    if (!this.ALL_PHYSICAL_REQUIREMENTS || !this.ALL_PHYSICAL_REQUIREMENTS.length || !this.event_requirements) return;

    this.PHYSICAL_REQUIREMENTS = _.differenceBy(this.ALL_PHYSICAL_REQUIREMENTS, this.event_requirements, "id");
  }

  removeRequirement(index, requirement) {
    this.setLoader();
    this.event_requirements.splice(index, 1);
    this.filterRequirements();
    this.$events.removeShiftRequirement(this.$stateParams.eventId, requirement.id).then((e) => {
      this.displaySuccessBanner();
      this.unSetLoader();
      console.log("Removed shift requirement:", e);
    });
  }

  checkForExistingRequirement(selectedReq) {
    let result;

    result = _.find(this.event_requirements, function (obj) {
      if (obj.id === selectedReq) {
        return true;
      }
    });

    return result;
  }

  addRequirement(q) {
    if (!q) {
      //alert("Select a different requirement.");
      return;
    }

    if (this.event_requirements.length >= 5) {
      this.newRequirement = null;
      alert("You can only have a maximum of 5 requirements.");
      return;
    }

    let doesExist = this.checkForExistingRequirement(q);

    if (doesExist === true) {
      this.newRequirement = null;
      alert("This requirement already exists.");
      return;
    }

    this.setLoader();
    this.event_requirements.push(q);
    this.newRequirement = null;
    this.filterRequirements();

    this.$events.addShiftRequirement(this.$stateParams.eventId, q.id, this.event_requirements.length).then((e) => {
      this.unSetLoader();
      this.displaySuccessBanner();
    });
  }

  showTimeToHire() {
    setTimeout(function () {
      jQuery("#datepicker").datepicker({
        showOn: "both",
        buttonImage: "/app/vendor/images/calender.png",
        buttonImageOnly: true,
        buttonText: "Select date",
        dateFormat: "M dd, yy",
      });
    }, 100);
  }

  showDateAndTimeUI(index) {
    // for date and time picker UI
    setTimeout(function () {
      jQuery("#datepicker-" + index.toString()).datepicker({
        showOn: "both",
        buttonImage: "/app/vendor/images/calender.png",
        buttonImageOnly: true,
        buttonText: "Select date",
        dateFormat: "M dd, yy",
      });
      jQuery("input.timepicker").timepicker({
        step: 15,
        timeFormat: "h:i A",
      });
      jQuery("input.timepicker").on("showTimepicker", function () {
        // //console.log("show");
        jQuery(".ui-timepicker-wrapper").css("width", $(this).width() + 10 + "px");
      });
    }, 100);
  }

  changePostedAllJobblers() {
    var _this = this;
    if (this.event.postedAllJobblers) {
      _this.teams.forEach(function (team) {
        team.postedEvent = true;
      });
    } else {
      _this.teams.forEach(function (team) {
        team.postedEvent = false;
      });
    }
  }

  changePostedToTeam(selectedTeam) {
    var _this = this;
  }

  changePrivate() {
    var _this = this;

    if (!_this.isPrivateJob) {
      _this.$timeout(function () {
        _this.$rootScope.$apply(function () {
          _this.isPrivateJob = false;
        });
      });
    } else {
      _this.$timeout(function () {
        _this.$rootScope.$apply(function () {
          _this.isPrivateJob = true;
        });
      });
    }
  }

  changedEventData(changedJobbleData = false, openingsChanging) {
    this.event.onsiteManagerNumber = this.event.onsiteManagerNumber
      ? this.event.onsiteManagerNumber.replace(/\D/g, "")
      : this.event.onsiteManagerNumber;

    this.event.changedEventData = true;
    this.event.changedJobbleData = changedJobbleData;

    if (this.event.numberOfOpenings <= 0) {
      this.event.numberOfOpenings = 1;
      alert("The number of openings cannot be below 1");
      return;
    }

    if (this.delivery) {
      this.deliveryDataChanged();
    }
  }

  changedJobbleDataPay(type) {
    var _this = this;
    let is_admin = null;
    if (_this.currentUser.username.indexOf("jobble.com") > -1 || _this.currentUser.username.indexOf("jobbleapp.com") > -1) {
      is_admin = true;
    } else {
      is_admin = false;
    }
    if (is_admin) {
      _this.event.changedJobbleData = true;
    } else {
      if (moment().isAfter(moment(_this.event.startTime)) || _this.event.numberOfApprovedApplications > 0) {
        alert("Error: You cannot edit the hourly rate after a job has started or after an applicant has been hired.");
      } else {
        _this.event.changedJobbleData = true;
      }
    }
    if (_this.delivery) {
      _this.deliveryDataChanged();
    }
    if (type === 1) {
      _this.calcNumbers();
    } else {
      _this.calcNumbersAdj();
    }
  }

  calcNumbers() {
    var _this = this;

    var companyFeePct = _this.currentUser.company.defaultPlan.companyFeePct;

    if (isNaN(_this.event.payPerHourAdj)) {
      _this.event.payPerHourAdj = "";
      _this.event.payPerHourAdj = (parseFloat(_this.event.event.payPerHour) * (1 - _this.currentUser.company.defaultPlan.jobblerFeePct)).toFixed(2);
    } else {
      let costLessMarkUp = parseFloat(_this.event.payPerHour) / (1 + companyFeePct);

      _this.event.payPerHourAdj = Math.round(costLessMarkUp * 100) / 100;

      if (isNaN(_this.event.payPerHourAdj)) {
        _this.event.payPerHourAdj = "";
      }
    }
  }

  calcNumbersAdj() {
    var _this = this;

    var companyFeePct = _this.currentUser.company.defaultPlan.companyFeePct;

    if (isNaN(_this.event.payPerHour)) {
      _this.event.payPerHour = "";
    } else {
      let costPlusMarkUp = Math.round(parseFloat(_this.event.payPerHourAdj) * 100 * (1 + companyFeePct));
      _this.event.payPerHour = (costPlusMarkUp / 100).toFixed(2);
      //20 = (x * 100) * (1 + companyFeePct);
      //20 = (100x) * 1.39

      if (isNaN(_this.event.payPerHour)) {
        _this.event.payPerHour = "";
      }
    }
  }

  changedJobbleData() {
    var _this = this;

    _this.event.changedJobbleData = true;

    if (moment().isAfter(moment(_this.event.startTime)) && _this.postType === "regular") {
    } else {
    }
  }

  addShift() {
    var _this = this;

    var newShift = null;
    var lastShift = _this.shifts[_this.shifts.length - 1];

    newShift = jQuery.extend(true, {}, lastShift);
    newShift.jobbleId = _this.event.subEvents[0].deduppedJobbles[0].id;
    newShift.id = null;

    newShift.googleCoords = {};
    newShift.googleCoords.lat = newShift.contactInfo.lat;
    newShift.googleCoords.lng = newShift.contactInfo.lng;

    _this.shifts.push(newShift);
    _this.showDateAndTimeUI(_this.shifts.length - 1);
  }

  removeShift(index) {
    var shiftCount = this.event.subEvents[0].deduppedJobbles[0].shifts.length;

    if (shiftCount > 1) {
      this.event.subEvents[0].deduppedJobbles[0].shifts.splice(index, 1);
      this.shiftsEdited = true;
    } else {
      alert("You cannot delete your last shift.");
    }
  }

  setWindowScrollTop() {
    var _this = this;
  }

  saveEventUpdate() {
    var _this = this;
    var status = this.validateEventForm();

    this.updateStatus = 0;

    if (status.status) {
      this.isEventUpdateValidateError = false;
      this.updateStatus = 1;

      if (_this.event.isLongTerm) {
        _this.triggerConfirmationModal();
        return;
      }

      this.updateEventData();
      _this.$timeout(function () {
        _this.setWindowScrollTop();
      }, 100);
    } else {
      this.isEventUpdateValidateError = true;
      this.updateStatus = 2;
      this.errorMessage = status.message;
      this.setWindowScrollTop();
    }
  }

  triggerConfirmationModal() {
    this.$timeout(function () {
      $("#modal-confirm-data-propagation").modal();
    });
  }

  editAllWeeks() {
    this.updateEventData(true);
  }

  editOneWeek() {
    this.updateEventData();
  }

  validateEventForm() {
    var retObj = {};

    retObj.status = true;

    const jobblerRate = parseFloat(this.event.payPerHourAdj);

    if (this.$security.isUndefinedOrNull(this.event.name)) {
      retObj.status = false;
      retObj.message = "Please provide a name for your job before continuing.";
      return retObj;
    }

    if (this.$security.isUndefinedOrNull(this.event.description)) {
      retObj.status = false;
      retObj.message = "Please provide some job details for your job before continuing.";
      return retObj;
    }

    if (this.$security.isUndefinedOrNull(this.event.payPerHour) && this.postType === "regular") {
      retObj.status = false;
      retObj.message = "Please provide an hourly rate for your job before continuing.";
      return retObj;
    }

    if (jobblerRate < 12.0) {
      retObj.status = false;
      retObj.message = "The Jobblers' pay rate cannot be less than $12.00.";
    }

    return retObj;
  }

  alert_user(err, shift_number) {
    var _this = this;
    _this.$timeout(function () {
      alert(err);
    }, 300);
  }

  compareShiftsToEachOther(shifts) {
    var shiftsForCompare = shifts;
    var r = {};

    r.status = false;

    var _this = this;

    try {
      shifts.sort(function (a, b) {
        return new Date(a.startDateAndTimeForDB).getTime() - new Date(b.startDateAndTimeForDB).getTime();
      });
    } finally {
      try {
        shifts.forEach(function (shift, i) {
          var indexPlusOne = i + 1;
          if (i + 1 < shifts.length) {
            var shiftEndTime = shift.endDateAndTimeMomentObj;
            var startTimeOfNextShift = shiftsForCompare[indexPlusOne].startDateAndTimeMomentObj;
            if (startTimeOfNextShift.isBefore(shiftEndTime)) {
              r.status = true;
              r.message = "You have selected overlapping shifts. Please fix before proceeding.";
              return r;
            }
          }
        });
      } finally {
        return r;
      }
    }
  }

  updateStartTimeModel(index, shift) {
    var _this = this;

    _this.$timeout(function () {
      var startTime = jQuery("#timepicker-" + index.toString()).val();
      if (startTime != undefined && startTime != null) {
        shift.startTime = startTime;
      }
    });
  }

  updateEventData(editAllWeeks) {
    var _this = this;

    let payload = {
      name: _this.event.name,
      eventType: _this.event.eventTypeId,
      arrivalInstructions: _this.event.arrivalInstructions,
      onsiteManagerName: _this.event.onsiteManagerName,
      onsiteManagerNumber: _this.event.onsiteManagerNumber,
      description: _this.cleanJobDescription(_this.event.description),
    };

    if (editAllWeeks) {
      payload.updateScheduled = true;
    }

    var eventData = {
      method: "PUT",
      url: _this.$env.getAPIEndPoint() + "jbl/v1/events/" + _this.event.id + "?format=json&conf=web",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + _this.currentUser.access_token,
      },
      data: payload,
    };

    if (this.event.changedEventData) {
      _this.remain_loading_count++;
      _this.$http(eventData).then(
        function (response) {
          _this.remain_loading_count--;
          _this.updateOpenings(editAllWeeks);

          if (editAllWeeks && !_this.event.changedJobbleData) {
            _this.showWaitForPropagationMessage();
          }
        },
        function (response) {
          _this.remain_loading_count--;
          _this.$timeout(function () {
            jQuery("#show-application-alert").trigger("click");
          }, 100);
        }
      );
    } else {
      _this.updateJobblePoolData(editAllWeeks);
    }
  }

  updateOpenings(editAllWeeks) {
    var _this = this;
    let data = {};

    if (_this.event.numberOfOpenings > _this.event.numberOfOpeningsOrigin) {
      data = {
        method: "POST",
        url:
          _this.$env.getAPIEndPoint() +
          "jbl/v1/jobbles/" +
          _this.event.subEvents[0].deduppedJobbles[0].id +
          "/add-positions?format=json&conf=web&numberOfPositions=" +
          (_this.event.numberOfOpenings - _this.event.numberOfOpeningsOrigin),
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: "Bearer " + _this.currentUser.access_token,
        },
        data: {},
      };
      _this.updateOpeningsReq(data);
    } else if (_this.event.numberOfOpenings < _this.event.numberOfOpeningsOrigin) {
      data = {
        method: "POST",
        url:
          _this.$env.getAPIEndPoint() +
          "jbl/v1/jobbles/" +
          _this.event.subEvents[0].deduppedJobbles[0].id +
          "/rm-positions?format=json&conf=web&numberOfPositions=" +
          (_this.event.numberOfOpeningsOrigin - _this.event.numberOfOpenings),
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: "Bearer " + _this.currentUser.access_token,
        },
        data: {},
      };
      _this.updateOpeningsReq(data);
    } else {
      _this.updateSubEventData(editAllWeeks);
    }
  }

  updateOpeningsReq(data) {
    var _this = this;
    _this.remain_loading_count++;

    _this.$http(data).then(
      function (response) {
        _this.remain_loading_count--;
        if (response.data.status !== "error") {
          _this.updateSubEventData();
        }
      },
      function (response) {
        _this.remain_loading_count--;
      }
    );
  }

  updateJobblePoolData(editAllWeeks) {
    var _this = this;

    let pay = Math.round(_this.event.payPerHourAdj * 100);

    let payload = {
      jobble: {
        jobbleType: _this.event.subEvents[0].deduppedJobbles[0].jobbleType.id,
        description: _this.cleanJobDescription(_this.event.description),
        payPerHour: pay,
        dressCode: _this.event.subEvents[0].deduppedJobbles[0].dressCode,
        manager: _this.manager_id_for_edit,
        subEvent: {
          event: {
            onsiteManagerName: _this.event.onsiteManagerName,
            onsiteManagerNumber: _this.event.onsiteManagerNumber,
          },
        },
      },
    };

    if (editAllWeeks) {
      payload.updateScheduled = true;
    }

    var jobblePoolData = {
      method: "PUT",
      url: _this.$env.getAPIEndPoint() + "jbl/v1/jobbles/" + _this.event.subEvents[0].deduppedJobbles[0].id + "/bulk-update?format=json",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + _this.currentUser.access_token,
      },
      data: payload,
    };

    if (_this.event.changedJobbleData) {
      _this.remain_loading_count++;
      _this.$http(jobblePoolData).then(
        function (response) {
          _this.remain_loading_count--;
          _this.event.changedJobbleData = false;
          if (editAllWeeks) {
            _this.showWaitForPropagationMessage();
          }
          _this.$timeout(function () {
            jQuery("#modal-save-event-confirm").trigger("click");
          }, 100);
          //_this.	();
        },
        function (response) {
          _this.remain_loading_count--;
          _this.$timeout(function () {
            jQuery("#show-application-alert").trigger("click");
          }, 100);
        }
      );
    } else {
      //_this.updateJobbleShiftsData();
    }
  }

  showWaitForPropagationMessage() {
    console.log("showWaitForPropagationMessage");
    this.$timeout(function () {
      jQuery("#modal-confirm-data-propagation-wait").modal();
    }, 100);
  }

  createNewShiftInExistingJob(shift) {
    var _this = this;

    var tempShift = {
      jobbleId: shift.jobbleId,
      contactInfo: {
        city: shift.contactInfo.city,
        state: shift.contactInfo.state,
        streetLine1: shift.contactInfo.streetLine1,
        zipCode: shift.contactInfo.zipCode,
        lat: shift.contactInfo.lat,
        lng: shift.contactInfo.lng,
      },
      timeInterval: {
        startTime: shift.timeInterval.startTime,
        endTime: shift.timeInterval.endTime,
      },
      overnight: shift.overnight,
      description: shift.description,
      location: shift.location,
      deliveryContactInfo: shift.deliveryContactInfo,
    };

    _this.$events.createNewShiftForExistingEvent(shift.jobbleId, null, null, shift).then(
      function (response) {
        _this.setShiftIdToShift(shift, response);
        _this.unSetLoader();
        _this.displaySuccessBanner();
      },
      function (error) {
        _this.unSetLoader();
        console.log("createNewShiftForExistingEvent - error");
        console.dir(error);
        if (error.data.code === 1007) {
          alert("You have reached the maximum number of shifts at 15. Please create a new job if more shifts are required.");
        } else {
          _this.$timeout(function () {
            jQuery("#show-application-alert").trigger("click");
          }, 100);
        }
      }
    );
  }

  setShiftIdToShift(shift, response) {
    var _this = this;

    shift.id = response.data.shiftId;
    shift.jobbleId = null;
  }

  displaySuccessBanner() {
    var _this = this;

    _this.$timeout(function () {
      $(".jobs-complete-banner .alert-success-header").show("slide", {direction: "up"}, 100);
    }, 400);

    _this.$timeout(function () {
      _this.hideSuccessBanner();
    }, 1500);
  }

  hideSuccessBanner() {
    var _this = this;

    _this.$timeout(function () {
      $(".jobs-complete-banner .alert-success-header").hide("slide", {direction: "up"}, 100);
    });
  }

  updateEventPostedToTeams(isPriv) {
    var _this = this;

    var ids = [];

    try {
      for (var i = 0; i < _this.teams.length; i++) {
        if (_this.teams[i].isSelected) {
          ids.push(_this.teams[i].id);
        }
      }
    } finally {
      var eventPostedToTeamsData = {
        method: "POST",
        url: _this.$env.getAPIEndPoint() + "jbl/v1/circles/push-jobbles-to-circles?format=json&conf=web",
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: "Bearer " + _this.currentUser.access_token,
        },
        data: {
          event: _this.event.id,
          subEvent: _this.event.subEvents[0].id,
          jobbles: [_this.event.subEvents[0].deduppedJobbles[0].id],
          circles: ids,
          forCircleOnly: isPriv,
        },
      };
      _this.remain_loading_count++;
      _this.$http(eventPostedToTeamsData).then(
        function (response) {
          _this.remain_loading_count--;
          //console.log(response.data);
        },
        function (response) {
          _this.remain_loading_count--;
          //console.log(response.data);
          _this.$timeout(function () {
            jQuery("#show-application-alert").trigger("click");
          }, 100);
        }
      );
    }
  }

  navigateEditEventPage(type) {
    var _this = this;
    _this.navOptions.forEach(function (option) {
      if (option.type === type) {
        option.isActive = "active";
      } else {
        option.isActive = "";
      }
    });
    if (type === "edit-job") {
      _this.activeTab = "edit-job";
      _this.setHiringManager(_this.event);
    }
    if (type === "push-teams") {
      _this.activeTab = "push-teams";
    }
    if (type === "edit-questions") {
      _this.activeTab = "edit-questions";
      _this.questions = _this.event.surveyQuestions;
      _this.$timeout(function () {
        _this.$rootScope.$apply(function () {
          _this.$rootScope.$broadcast("checkQuestionsEdit", {
            questions: _this.questions,
            event: _this.event,
          });
        });
      }, 100);
    }

    if (type === "edit-requirements") {
      _this.activeTab = "edit-requirements";
    }

    if (type === "edit-shifts") {
      _this.activeTab = "edit-shifts";
      _this.event.subEvents[0].deduppedJobbles[0].shifts.forEach(function (shift, index) {
        shift.address =
          shift.contactInfo.streetLine1 + " " + shift.contactInfo.city + " " + shift.contactInfo.state + " " + shift.contactInfo.zipCode;
        // shift.startDate = moment.utc(shift.timeInterval.startTime).toDate();
        shift.startDate = moment(moment.utc(shift.timeInterval.startTime).toDate()).format("MMM DD, YYYY");
        shift.startTime = moment(moment.utc(shift.timeInterval.startTime).toDate()).format("hh:mm A");
        shift.totalMinutes = parseInt(moment.utc(shift.timeInterval.endTime).diff(moment.utc(shift.timeInterval.startTime)) / 60000);
        shift.minutes = shift.totalMinutes % 60;

        shift.hours = parseInt((shift.totalMinutes - shift.minutes) / 60);
        shift.isChangedAddress = false;
        _this.showDateAndTimeUI(index);
      });
    }
  }

  confirmJobEdit() {
    this.$timeout(function () {
      jQuery("#modal-save-event-confirm .modal-header button.close").trigger("click");
    }, 100);
  }

  saveUpdatedTeams() {
    var _this = this;
    var circles = [];
    _this.teams.forEach(function (team) {
      if (team.isSelected) {
        circles.push(team.id);
      }
    });

    _this.$timeout(function () {
      jQuery("#push-team-modal-confirm").modal();
      _this.circles = circles;
    }, 100);
  }

  timeToHireChange() {
    var _this = this;

    if (moment(_this.event.timeToHireFormatted).isBefore(moment())) {
      alert("Please select a date in the future to hire.");
      _this.event.timeToHireFormatted = moment(_this.event.timeToHire).format("MMM DD, YYYY");
    } else {
      _this.event.timeToHire = moment(_this.event.timeToHireFormatted).format();
      _this.event.changedEventData = true;
    }
  }

  sortShiftsInOrder(shifts, event) {
    var _this = this;
    try {
      shifts.sort(function (a, b) {
        return new Date(a.timeInterval.startTime) - new Date(b.timeInterval.startTime);
      });
    } finally {
      var shiftsHolder = [];

      shiftsHolder.push(shifts);
      _this.shiftsHolder = shiftsHolder;

      _this.updateLongTermGenerator(shifts, event);

      _this.$timeout(function () {
        _this.shifts = shifts;
        _this.shifts.forEach(function (shift) {
          shift.totalMinutes = parseInt(moment.utc(shift.timeInterval.endTime).diff(moment.utc(shift.timeInterval.startTime)) / 60000);
          shift.minutes = shift.totalMinutes % 60;
        });
      });

      _this.check_for_delivery();
    }
  }

  check_for_delivery() {
    var _this = this;
    if (_this.event.isOrder) {
      _this.delivery = true;
      _this.setFields();
    } else {
      _this.delivery = false;
    }

    _this.setNavBar();
  }

  setFields() {
    var _this = this;
    _this.order = {
      contact: _this.event.subEvents[0].deduppedJobbles[0].deliveryContactInfo,
      pickup: {
        instructions: _this.event.subEvents[0].deduppedJobbles[0].shifts[0].description,
        contact: _this.event.subEvents[0].deduppedJobbles[0].pickupContactInfo,
      },
      dropoff: {
        instructions: _this.event.subEvents[0].deduppedJobbles[0].shifts[1].description,
        contact: _this.event.subEvents[0].deduppedJobbles[0].dropoffContactInfo,
      },
    };

    _this.remain_loading_count = 0;
  }

  validateJobbleShifts(s, index) {
    var _this = this;

    var retObj = {};
    var shift;

    retObj.status = true;

    var shiftsToSave = [];

    shiftsToSave.push(s);

    for (var i = 0; i < shiftsToSave.length; i++) {
      shift = shiftsToSave[i];

      var shifthold = shift;

      if (this.postType === "regular") {
        _this.updateStartTimeModel(index, shift);
        if (this.$security.isUndefinedOrNull(shift.startDate)) {
          retObj.status = false;
          retObj.message = "Please provide the date of the shift #" + (i + 1).toString();
          return retObj;
        }
        if (this.$security.isUndefinedOrNull(shift.startTime)) {
          retObj.status = false;
          retObj.message = "Please provide the time of the shift #" + (i + 1).toString();
          return retObj;
        }
        if (shift.hours == 0 && shift.minutes == 0) {
          retObj.status = false;
          retObj.message = "Please provide the duration of the shift #" + (i + 1).toString();
          return retObj;
        }
      }

      if (shift.isChangedAddress) {
        try {
          shift.contactInfo = {};
          shift.googleCoords = {};
          shift.googleCoords.lat = shift.address.lat;
          shift.googleCoords.lng = shift.address.lng;

          if (shift.address.adr_address.indexOf("span") > -1) {
            var addressSplit = shift.address.adr_address.split(",");

            addressSplit.forEach(function (part, index) {
              //console.log("splitting...");
              //console.dir(part);

              if (part.indexOf("street-address") > -1) {
                var streetArray = /<span[^>]*>(.*?)<\/span>/.exec(part);
                shift.contactInfo.streetLine1 = streetArray[1];
              }
              if (part.indexOf("locality") > -1) {
                var cityArray = /<span[^>]*>(.*?)<\/span>/.exec(part);
                shift.contactInfo.city = cityArray[1];
              }
              if (part.indexOf("region") > -1) {
                var regionAndZipArray = part.split("> <");

                regionAndZipArray.forEach(function (p) {
                  if (p.indexOf("region") > -1) {
                    var stateArray = /\s<span[^>]*>(.*?)<\/span/.exec(p);
                    shift.contactInfo.state = stateArray[1];
                  }
                  if (p.indexOf("postal-code") > -1) {
                    var zipArray = /span[^>]*>(.*?)<\/span>/.exec(p);
                    shift.contactInfo.zipCode = zipArray[1];
                  }
                });
              }

              if (index + 1 === addressSplit.length) {
                shift.address =
                  shift.contactInfo.streetLine1 + " " + shift.contactInfo.city + " " + shift.contactInfo.state + " " + shift.contactInfo.zipCode;
                shift.isChangedAddress = false;
              }
            });
          }
        } catch (err) {
          retObj.status = false;
          retObj.message = "Please provide the correct address of the shift" + (i + 1).toString();

          return retObj;
        }
      }

      if (this.$security.isUndefinedOrNull(shift.contactInfo)) {
        retObj.status = false;
        retObj.message =
          "Please make sure to select an address of the shift" +
          (i + 1).toString() +
          " from the drop down before proceeding. Please do not copy and paste.";
        return retObj;
      } else if (
        this.$security.isUndefinedOrNull(shift.contactInfo.city) ||
        this.$security.isUndefinedOrNull(shift.contactInfo.streetLine1) ||
        this.$security.isUndefinedOrNull(shift.contactInfo.state) ||
        this.$security.isUndefinedOrNull(shift.contactInfo.zipCode)
      ) {
        retObj.status = false;
        retObj.message =
          "Please return a more specific address of the shift" +
          (i + 1).toString() +
          ". For best results use a street address. (100 Main St. Boston, MA).";
        return retObj;
      }

      if (this.postType === "regular") {
        var tempEndDate = moment(shift.startDate + " " + shift.startTime).add(shift.hours, "hours");
        shift.endDateAndTimeMomentObj = moment(tempEndDate).add(shift.minutes, "minutes");
        shift.durationInMinutes = shift.endDateAndTimeMomentObj.diff(moment(shift.startDate + " " + shift.startTime), "minutes");
        shift.durationInHours = parseFloat((shift.durationInMinutes / 60).toFixed(2));
        shift.startDateAndTimeMomentObj = moment(shift.startDate + " " + shift.startTime);
        console.log("shift.startDateAndTimeMomentObj");
        console.dir(shift.startDateAndTimeMomentObj);
        shift.startDateAndTimeForDB = shift.startDateAndTimeMomentObj.format();
        console.dir(shift.startDateAndTimeForDB);
        shift.endDateAndTimeForDB = shift.endDateAndTimeMomentObj.format();
        shift.startTime = moment(shift.startDateAndTimeForDB).format("hh:mm A");
        shift.endTime = moment(shift.endDateAndTimeForDB).format("hh:mm A");
      } else {
        shift.timeInterval.endTime = moment(shift.timeInterval.endTime).add(this.additionalDays, "days").format();
      }

      if (this.postType === "regular") {
        if (i === 1 && _this.delivery) {
          let st2 = _this.event.subEvents[0].deduppedJobbles[0].shifts[i].startDateAndTimeForDB;
          let st = _this.event.subEvents[0].deduppedJobbles[0].shifts[i - 1].startDateAndTimeForDB;
          if (moment(st2).isBefore(moment(st))) {
            retObj.status = false;
            retObj.message = "The drop-off time must be after the pick-up time.";
            return retObj;
          }
        }
      }

      if (this.$security.isUndefinedOrNull(shift.contactInfo)) {
        retObj.status = false;
        retObj.message = "Please make sure to select an address from the drop down before proceeding. Please do not copy and paste.";
        return retObj;
      } else {
        if (
          this.$security.isUndefinedOrNull(shift.contactInfo.city) ||
          this.$security.isUndefinedOrNull(shift.contactInfo.streetLine1) ||
          this.$security.isUndefinedOrNull(shift.contactInfo.state) ||
          this.$security.isUndefinedOrNull(shift.contactInfo.zipCode)
        ) {
          retObj.status = false;
          retObj.message = "Please return a more specific address. For best results use a street address. (100 Main St. Boston, MA).";
          return retObj;
        }
      }

      if (this.postType === "regular") {
        shift.timeInterval.startTime = shift.startDateAndTimeForDB;
        shift.timeInterval.endTime = shift.endDateAndTimeForDB;
      }

      if (this.postType === "source") {
        //console.log('what is this after the adding');
        //console.dir(shift);
      }
    }

    return retObj;
  }

  shiftChanged(shift, index, isAddress) {

    var _this = this;

    console.log("shiftChanged");
    console.dir(isAddress);

    shift.has_been_changed = true;
    _this.shiftIsBeingEdited = true;

    if (!_this.shiftsEdited) {
      _this.shiftsEdited = true;
    }

    shift.startTime = shift.startTimeFormatted;
    shift.startDate = shift.startDateFormatted;

    if (isAddress) {
      shift.isChangedAddress = true;
      if (typeof shift.address === "object") {
        _this.showSaveButton(shift, index);
      }
    } else {
      _this.showSaveButton(shift, index);
    }
  }

  showSaveButton(shift, index) {
    var _this = this;

    shift.shift_has_been_changed = true;
  }

  checkShift(shift) {
    var _this = this;

    if (shift.isChecked) {
      shift.isChecked = false;
    } else {
      shift.isChecked = true;
    }
  }

  saveShiftEdit(shift, index) {
    var _this = this;

    _this.setLoader();

    shift.has_been_changed = false;
    var status = this.validateJobbleShifts(shift, index);
    console.log("saveShiftEdit");
    console.dir(shift);
    console.dir(index);
    console.log("status");
    console.dir(status);

    if (status.status) {
      console.log("this.postType");
      console.dir(this.postType);

      if (this.postType === "regular") {
        var errorWithShifts = _this.compareShiftsToEachOther(_this.event.subEvents[0].deduppedJobbles[0].shifts);
        if (!errorWithShifts.status) {
          _this.isEventUpdateValidateError = false;
          _this.updateStatus = 1;
          _this.updateJobbleShiftsData(shift);
        } else {
          _this.isEventUpdateValidateError = true;
          _this.updateStatus = 2;
          _this.errorMessage = errorWithShifts.message;
          _this.setWindowScrollTop();
          _this.shiftIsBeingEdited = false;
          _this.unSetLoader();
        }
      } else {
        _this.isEventUpdateValidateError = false;
        _this.updateStatus = 1;
        _this.updateJobbleShiftsData();
        _this.shiftIsBeingEdited = false;
      }
    } else {
      this.unSetLoader();
      this.shiftIsBeingEdited = false;
      this.isEventUpdateValidateError = true;
      this.updateStatus = 2;
      this.errorMessage = status.message;
      this.setWindowScrollTop();
    }
  }

  updateJobbleShiftsData(s) {
    var _this = this;
    var shifts = [];
    var shiftsHolder = [];
    var shiftCount = _this.event.subEvents[0].deduppedJobbles[0].shifts.length;
    var processedShiftCount = 0;

    shiftsHolder.push(s);

    _this.$timeout(function () {
      _this.shiftIsBeingEdited = false;
    }, 1000);

    shiftsHolder.forEach(function (shift, index) {
      _this.$security.getEventShiftTimezoneInfo(shift).then(
        function (response) {
          processedShiftCount++;

          if (_this.postType === "regular") {

            var zone = moment.tz.zone(moment.tz.guess());
            var eventMangerOffsets = -zone.offsets[zone.offsets.length - 1];
            var eventOffsets = response.data[0].rawOffset / 60000;

            let tz = response.data[0].timeZoneId;
            let td = new Date(shift.startDate);
            let tt = new Date(shift.startTime);

            var tempEndDate = moment(shift.startDate + " " + shift.startTime).add(shift.hours, "hours");

            shift.endDateAndTimeMomentObj = moment(tempEndDate).add(shift.minutes, "minutes");
            shift.endTime = shift.endDateAndTimeMomentObj.format("h:mm a");
            console.log("check end time");
            console.dir(shift);
            console.dir(shift.endTime);
            shift.durationInMinutes = shift.endDateAndTimeMomentObj.diff(moment(shift.startDate + " " + shift.startTime), "minutes");
            shift.durationInHours = parseFloat((shift.durationInMinutes / 60).toFixed(2));
            shift.startDateAndTimeMomentObj = moment(shift.startDate + " " + shift.startTime);

            shift.startDateFormattedNew = shift.startDateAndTimeMomentObj.tz(tz).format("M/D/YYYY");
            shift.endDateFormattedNew = shift.endDateAndTimeMomentObj.tz(tz).format("M/D/YYYY");

            shift.startDateAndTimeForDB = moment.tz(`${shift.startDateFormattedNew} ${shift.startTime}`, "M/D/YYYY h:mm a", tz);
            shift.endDateAndTimeForDB = moment.tz(`${shift.endDateFormattedNew} ${shift.endTime}`, "M/D/YYYY h:mm a", tz);

            shift.timeInterval.startTime = shift.startDateAndTimeForDB.format();
            shift.timeInterval.endTime = shift.endDateAndTimeForDB.format();

            if (shift.googleCoords) {
              shift.contactInfo.lat = shift.googleCoords.lat;
              shift.contactInfo.lng = shift.googleCoords.lng;
            }
          }

          if (shift.jobbleId) {
            _this.createNewShiftInExistingJob(shift);
            return;
          }

          var tempShift = {
            id: shift.id,
            contactInfo: {
              city: shift.contactInfo.city,
              state: shift.contactInfo.state,
              streetLine1: shift.contactInfo.streetLine1,
              zipCode: shift.contactInfo.zipCode,
              lat: shift.contactInfo.lat,
              lng: shift.contactInfo.lng,
            },
            timeInterval: {
              startTime: shift.timeInterval.startTime,
              endTime: shift.timeInterval.endTime,
            },
            overnight: shift.overnight,
            unpaidBreak: shift.unpaidBreak,
          };

          shifts.push(tempShift);

          _this.$events.updateExistingShift(tempShift, s.isChecked).then(
            function (response) {
              _this.unSetLoader();
              _this.shiftIsBeingEdited = false;
              _this.displaySuccessBanner();
            },
            function (error) {
              _this.unSetLoader();
              _this.shiftIsBeingEdited = false;
              _this.handleSavingShiftError(error);
            }
          );
        },
        function (response) {
          _this.remain_loading_count--;
          _this.$timeout(function () {
            jQuery("#show-application-alert").trigger("click");
          }, 100);
          return;
        }
      );
    });
  }

  handleSavingShiftError(error) {
    var _this = this;
    if (error.data.code === 1008) {
      alert("There are overlapping shifts. Please adjust the shift times and try again.");
    } else {
      _this.$timeout(function () {
        jQuery("#show-application-alert").trigger("click");
      }, 100);
    }
  }

  updateShiftUsingBulkShift(shift) {
    var _this = this;
  }

  setHiringManager(event) {
    var _this = this;

    let m = event.subEvents[0].deduppedJobbles[0].manager;

    if (m) {
      _this.$timeout(function () {
        _this.$rootScope.$emit("SetManagerForEditPage", m);
      });
    }
  }

  setNavBar() {
    var _this = this;
    if (_this.delivery) {
      _this.postType = "regular";
      _this.navOptions = [
        {
          type: "edit-job",
          isActive: "active",
          value: "Edit Delivery",
        },
        {type: "edit-shifts", isActive: "", value: "Edit Locations"},
      ];
    } else {
      if (_this.event.isSourcingPost) {
        _this.postType = "source";
        _this.navOptions = [
          {type: "edit-job", isActive: "active", value: "Edit job"},
        ];
      } else {
        _this.postType = "regular";
        _this.navOptions = [
          {type: "edit-job", isActive: "active", value: "Edit job"},
          {type: "edit-shifts", isActive: "", value: "Edit shifts"},
          {
            type: "edit-requirements",
            isActive: "",
            value: "Edit Requirements",
          },
        ];
      }
    }
  }

  cleanJobDescription(str) {
    if (str) {
      const updatedDescription = str.replace(/\\|`/g, "");
      return updatedDescription;
    }
  }

  deliveryDataChanged() {
    var _this = this;
    _this.event.changedDeliveryData = true;
  }

  saveDeliveryToSubevent(data) {
    var _this = this;
    let event = {};
    event.name = _this.event.name;
    event.description = _this.cleanJobDescription(_this.event.description);
    event.id = _this.event.subEvents[0].id;
    _this.$events.updateSubEventInfoForOrder(event).then(
      function (response) {
        _this.saveDeliveryToJobble();
      },
      function (error) {
        alert("Error saving event.");
      }
    );
  }

  saveDeliveryToJobble() {
    var _this = this;
    let jobble = {};
    jobble.pay = _this.event.payPerHour;
    jobble.pickup_contact = _this.order.pickup.contact;
    jobble.dropoff_contact = _this.order.dropoff.contact;
    jobble.description = _this.cleanJobDescription(_this.event.description);
    jobble.id = _this.event.subEvents[0].deduppedJobbles[0].id;
    _this.$events.updateJobbleInfoForOrder(jobble).then(
      function (response) {
        _this.$timeout(function () {
          _this.updateJobbleShiftsData();

          //_this.saveShiftEdit();
        }, 500);
      },
      function (error) {
        alert("Error during bulk update.");
      }
    );
  }

  updateSubEventData(editAllWeeks) {
    var _this = this;

    let payload = {
      name: _this.event.name,
      eventType: _this.event.eventTypeId,
      description: _this.cleanJobDescription(_this.event.description),
    };

    if (editAllWeeks) {
      payload.updateScheduled = true;
    }

    var subEventData = {
      method: "PUT",
      url: _this.$env.getAPIEndPoint() + "jbl/v1/subevents/" + _this.event.subEvents[0].id + "?format=json&conf=web",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + _this.currentUser.access_token,
      },
      data: payload,
    };
    _this.remain_loading_count++;
    _this.$http(subEventData).then(
      function (response) {
        _this.remain_loading_count--;
        _this.event.changedEventData = false;
        _this.updateJobblePoolData(editAllWeeks);
      },
      function (response) {
        _this.remain_loading_count--;
        //console.log(response.data);
        _this.$timeout(function () {
          jQuery("#show-application-alert").trigger("click");
        }, 100);
      }
    );
  }

  setLoader() {
    var _this = this;
    _this.$timeout(function () {
      $("html").addClass("wait");
    }, 300);
  }

  setNavBar() {
    var _this = this;
    if (_this.delivery) {
      _this.postType = "regular";
      _this.navOptions = [
        {type: "edit-job", isActive: "active", value: "Edit Delivery", icon: "shipping-fast"},
        {type: "edit-shifts", isActive: "", value: "Edit Locations", icon: "map-marker"},
      ];
    } else {
      if (_this.event.isSourcingPost) {
        _this.postType = "source";
        _this.navOptions = [
          {type: "edit-job", isActive: "active", value: "Edit job", icon: "tasks"},
          // {type: "edit-questions", isActive: "", value: "Edit questions", icon: "question"},
        ];
      } else {
        _this.postType = "regular";
        _this.navOptions = [
          {type: "edit-job", isActive: "active", value: "Edit job", icon: "tasks"},
          {type: "edit-shifts", isActive: "", value: "Edit shifts", icon: "clock-o"},
          // {type: "edit-questions", isActive: "", value: "Edit questions", icon: "question"},
          {type: "edit-requirements", isActive: "", value: "Edit requirements", icon: "asterisk"},
        ];
      }
    }
  }

  deliveryDataChanged() {
    var _this = this;
    _this.event.changedDeliveryData = true;
  }

  saveDeliveryUpdate() {
    var _this = this;
    let event = {};
    event.name = _this.event.name;
    event.description = _this.cleanJobDescription(_this.event.description);
    event.id = _this.event.id;
    _this.setLoader();
    _this.$events.updateEventInfoForOrder(event).then(
      function (response) {
        _this.saveDeliveryToSubevent();
      },
      function (error) {
        alert("Error saving event.");
      }
    );
  }

  saveDeliveryToSubevent(data) {
    var _this = this;
    let event = {};
    event.name = _this.event.name;
    event.description = _this.cleanJobDescription(_this.event.description);
    event.id = _this.event.subEvents[0].id;
    _this.$events.updateSubEventInfoForOrder(event).then(
      function (response) {
        _this.saveDeliveryToJobble();
      },
      function (error) {
        alert("Error saving event.");
      }
    );
  }

  unSetLoader() {
    var _this = this;
    _this.$timeout(function () {
      $("html").removeClass("wait");
    }, 300);
  }

  shiftHasBeenChecked(shift, index) {
    var _this = this;
    //console.log("shiftHasBeenChecked");
    //console.dir(shift);
    if (shift.selected) {
      shift.selected = false;
      _this.removeShiftFromSelection(shift, index);
    } else {
      shift.selected = true;
      _this.shiftsToBeDeleted.push(shift);
    }
  }

  deleteShift() {
    var _this = this;

    _this.setLoader();

    _this.$events.deleteShift(_this.shiftToBeDeleted).then(
      function (response) {
        _this.displaySuccessBanner();
        _this.unSetLoader();
        _this.closeDeleteModal();
      },
      function (error) {
        _this.unSetLoader();
        _this.closeDeleteModal();
        _this.$timeout(function () {
          alert("Something went wrong deleting a shift. Please contact admin : " + error.data.message);
        }, 300);
      }
    );
  }

  closeDeleteModal() {
    var _this = this;
    _this.shifts.splice(_this.shiftToBeDeletedIndex, 1);
  }

  selectedShiftToDelete(shift, index) {
    var _this = this;
    _this.shiftToBeDeleted = shift;
    _this.shiftToBeDeletedIndex = index;
    if (shift.id) {
      _this.$timeout(function () {
        $("#delete-shift-confirm").modal();
      });
    } else {
      _this.shifts.splice(_this.shiftToBeDeletedIndex, 1);
    }
  }

  removeShiftFromSelection(shift, index) {
    var _this = this;

    if (_this.shiftsToBeDeleted.length > 0) {
      let x = _this.shiftsToBeDeleted.findIndex((obj) => obj.id == shift.id);

      _this.shiftsToBeDeleted.splice(index, 1);
    }
  }

  deleteSelectedShifts() {
    var _this = this;

    let shifts = [];

    try {
      _this.shifts.forEach(function (s) {
        if (s.selected === true) {
        } else {
          shifts.push(s);
        }
      });
    } catch (err) {
      //console.log("looping error");
      //console.dir(err);
    } finally {
      _this.shifts = shifts;
      _this.event.subEvents[0].deduppedJobbles[0].shifts = shifts;

      _this.saveShiftEdit();
    }
  }

  shiftHasBeenClicked(shift) {
    var _this = this;
  }

  setShiftForDelete(shift) {
    var _this = this;
  }

  cancelShiftEdit(shift) {
    var _this = this;

    shift.has_been_changed = false;
    _this.shiftIsBeingEdited = false;
  }

  setAutoAccept(event) {
    if (event.autoAccept === true) {
      this.setAutoHire = true;
      this.autoHireStatus = "On";
    } else {
      this.setAutoHire = false;
      this.autoHireStatus = "Off";
    }
  }

  setAutoManage(event) {
    if (event.autoManage === true) {
      this.setAutoManage = true;
    } else {
      this.setAutoManage = false;
    }
  }

  toggleAutoHire() {
    this.setLoader();

    let payload = {};
    let checked = this.setAutoHire;

    if (checked === true) {
      payload.autoAccept = false;
      this.setAutoHire = false;
    } else {
      payload.autoAccept = true;
      this.setAutoHire = true;
    }

    this.$events.updateAutoHire(this.event, payload).then(
      (response) => {
        this.$timeout(() => {
          this.unSetLoader();
          this.handleAutoHireResponse(checked);
        }, 500);
      },
      (error) => {
        this.$timeout(() => {
          this.unSetLoader();
          this.handleAutoHireError();
        }, 500);
      }
    );
  }

  toggleAutoManage() {
    this.setLoader();

    let payload = {};
    let checked = this.setAutoManage;

    if (checked === true) {
      payload.autoManage = false;
      this.setAutoManage = false;
    } else {
      payload.autoManage = true;
      this.setAutoManage = true;
    }

    this.$events.updateAutoHire(this.event, payload).then(
      (response) => {
        this.$timeout(() => {
          this.unSetLoader();
          this.handleAutoManageResponse(checked);
        }, 500);
      },
      (error) => {
        this.$timeout(() => {
          this.unSetLoader();
          this.handleAutoManageError();
        }, 500);
      }
    );
  }

  getUpdatedData() {
    var _this = this;

    _this.setAutoAccept(_this.event);
    _this.setAutoManage(_this.event);
    _this.setHiringManager(_this.event);
    _this.checkForAdmin();

    _this.$timeout(function () {
      _this.unSetLoader();
    }, 2000);

    /*
        _this.$auth.refreshCurrentUser().then(
            function (response) {
                _this.currentUser = response;
            },
            function (error) {
                _this.unSetLoader();
            }
        );
         */
  }

  handleAutoManageResponse(checked) {
    if (this.setAutoManage === true) {
      alert("Your job has successfully turned Auto Manage on.");
    } else {
      alert("Your job has turned Auto Manage off.");
    }
  }

  handleAutoHireResponse(checked) {
    if (this.setAutoHire === true) {
      alert("Your job has successfully turned Auto Hire on.");
    } else {
      alert("Your job has turned Auto Hire off.");
    }
  }

  handleAutoHireError() {
    alert("There was an issue updating the jobs Auto Hiring process. Please contact support.");
  }

  checkForAdmin() {
    var _this = this;

    if (_this.currentUser.username.indexOf("jobble.com") > -1 || _this.currentUser.username.indexOf("jobbleapp.com") > -1) {
      _this.currentUser.isAdmin = true;
    } else {
      _this.currentUser.isAdmin = false;
    }
  }
}

EventeditdetailsController.$inject = [
  "$http",
  "$localStorage",
  "$state",
  "$stateParams",
  "auth",
  "events",
  "security",
  "$rootScope",
  "common",
  "companies",
  "env",
  "$timeout",
  "$scope",
];

export default EventeditdetailsController;



// WEBPACK FOOTER //
// ./client/app/components/eventeditdetails/eventeditdetails.controller.js